import { Modal, NewMomCard } from "@aph/ui-lib-humanx";
import { differenceInMonths } from "date-fns";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import { FirstFoldNewMom, HOME_TYPE } from "@/components/PageHome/api/interface";
import NewMomFlow from "@/components/PageHome/components/OnboardingSection/Flows/NewMom";
import styles from "@/components/PageHome/components/OnboardingSection/Onboarding.module.scss";
import { clearFlowData, setCurrentFlow } from "@/components/PageHome/redux/slice";
import { dateToString } from "@/helpers";
import { ONBOARDING_STATUS } from "@/helpers/constants";
import routes from "@/helpers/router";
import { buttonClickedEvent } from "@/helpers/TSDEvents";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";

interface NewMomProps {
  data: FirstFoldNewMom;
}

const NewMom: React.FC<NewMomProps> = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const router = useRouter();
  const dispatch = useAppDispatch();
  const signedInStatus = useAppSelector(signedInStateSelector);
  const isDOBNotRemember = !Boolean(data?.Birthday);

  const birthDate = isDOBNotRemember ? undefined : new Date(data?.Birthday);

  const openModal: () => void = () => {
    dispatch(clearFlowData());
    dispatch(setCurrentFlow(HOME_TYPE.NEW_MOM));
    setIsModalOpen(true);
  };

  const handleClevertapTracking = (props: { buttonName: string }) => {
    const { buttonName } = props;
    buttonClickedEvent({
      button_name: buttonName,
      momverse_stage: ONBOARDING_STATUS[HOME_TYPE.NEW_MOM],
      is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
    });
  };

  const handleCtaClick = () => {
    handleClevertapTracking({
      buttonName: isDOBNotRemember ? "Read about postpartum care" : "Read About Baby's Growth",
    });

    if (isDOBNotRemember) {
      router.push(routes.category("postpartum"));
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const childAge = differenceInMonths(today, birthDate) || 1;
      router.push(routes.cluster(`${childAge}-month-old-baby`));
    }
  };

  const childData = isDOBNotRemember
    ? [
        {
          label: "Add baby’s birthday",
          icon: "add",
          onClick: openModal,
        },
      ]
    : [
        {
          label: `Birthday: ${dateToString(birthDate, "do MMM''yy")}`,
          icon: "edit",
          onClick: openModal,
        },
      ];

  return (
    <div className={`container spacingBetweenSections ${styles.firstFoldContainer}`}>
      <NewMomCard
        className={styles.newMomCard}
        title={"Hello Mamma!"}
        subTitle={
          isDOBNotRemember
            ? "Share your baby’s birthday and track their growth to fully experience their incredible journey!"
            : "Your little one is growing every day!"
        }
        isDOBNotRemember={isDOBNotRemember}
        productImgUrl={data?.firstFoldImage}
        childAgeText={data?.childAge}
        childData={childData}
        ctaText={isDOBNotRemember ? "Read about postpartum care" : "Read About Baby's Growth"}
        ctaClick={handleCtaClick}
        nutritionTitle={data?.nutrition}
        sleepingTitle={data?.sleep}
        skillInfo={[
          { title: "Social skills", subTitle: data?.socialSkills },
          { title: "Motor skills", subTitle: data?.MotorSkills },
        ]}
        noteText={
          isDOBNotRemember
            ? ""
            : "Breast milk is as per the needs of the baby All these parameters are medically recommended"
        }
      />
      <Modal
        size="md"
        backdropClose
        mobileBottomAlign
        titleAlign="center"
        open={isModalOpen}
        handleOpen={(modalStatus: boolean) => {
          if (modalStatus === false) {
            setIsModalOpen(false);
          }
        }}
        isHXModal
        modalClass={styles.modalClass}
        titleClass={styles.titleClass}
        modalboxClass={styles.modalboxClass}
        modalContentClass={styles.innerSection}
      >
        <NewMomFlow birthDate={birthDate} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
      </Modal>
    </div>
  );
};

export default NewMom;
